<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Cargos (Pagos)' : 'Agregar Cargos (Pagos)' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button appPermissionControl="P136B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>{{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-back" mat-raised-button (click)="close()" appPermissionControl="P136B0001"><mat-icon>close</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P136F0001">
    <div class="form-row">
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P136K0001" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P136K0002" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="concepto" required appPermissionControl="P136K0003">
          <option value="">-- Selecciona --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Calcular</label>
        <select class="form-control" formControlName="calculate" appPermissionControl="P136K0004">
          <option value="">-- Selecciona --</option>
          <option *ngFor="let item of solicitudesValores" [value]="item.iValor">
            {{ item.sEtiqueta }}
          </option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>% Impuesto</label>
        <input class="form-control" formControlName="porcentaje" type="number" required appPermissionControl="P136K0005" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto Adicional</label>
        <select class="form-control" formControlName="conceptoAdicional" appPermissionControl="P136K0006">
          <option value="">-- Selecciona --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>
    </div>

    <div class="titleFm" style="width: 200px">FÓRMULA</div>
    <div class="content-section">
      <!-- Fórmula -->
      <div class="col-12">
        <div class="form-field">
          <input class="form-control" formControlName="formula" appPermissionControl="P136K0010" />
          <label>Fórmula</label>
        </div>
      </div>

      <div class="col-2">
        <strong>Variables:</strong>
      </div>

      <div class="col-5">
        <span><strong> PDB(concept ###, subconcept ###):</strong> Saldo pago vencido </span>
      </div>
      <div class="col-5">
        <span><strong> PTB(concept ###, subconcept ###):</strong> Pago saldo total </span>
      </div>
      <div class="col-2"></div>
      <div class="col-5">
        <span><strong> TOB(concept ###, subconcept ###):</strong> Saldo total </span>
      </div>
      <div class="col-5">
        <span><strong> TAB(concept ###, subconcept ###):</strong> Saldo total adeudado </span>
      </div>
      <div class="col-2"></div>
      <div class="col-5">
        <span> <strong>F([FA, FV, FP], ClaveTasa):</strong> Factor </span>
      </div>
      <div class="col-5">
        <span><strong> SP(Accion ##):</strong> Procedimiento de almacenamiento </span>
      </div>
    </div>
  </form>
</ng-container>
